import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: #f8f9fa;
  color: #343a40;
  text-align: center;
  font-family: Arial, sans-serif;
`;

const ErrorTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

const ErrorMessage = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
`;

export const ErrorPage = () => {
  const location = useLocation();
  const status = location.state ? location.state.status : "404";

  return (
    <ErrorContainer>
      <ErrorTitle>Oops!</ErrorTitle>
      <ErrorMessage>Something went wrong. Error {status}.</ErrorMessage>
    </ErrorContainer>
  );
};

export default ErrorPage;
